/**
 * Injects the Adjust Smart Script.
 */
export function injectAdjustSmartScript() {
  if (document.querySelector(`script[id="${ADJUST_SMART_SCRIPT_ID}"]`)) {
    return;
  }

  const script = document.createElement('script');
  script.id = ADJUST_SMART_SCRIPT_ID;
  script.type = 'text/javascript';
  script.src = ADJUST_SMART_SCRIPT_URL;
  script.defer = true;

  document.head.appendChild(script);
}

// ─── Constants ───────────────────────────────────────────────────────────────

const ADJUST_SMART_SCRIPT_ID = 'adjust-smart-script';
const ADJUST_SMART_SCRIPT_URL = '/adjust-smart-script.js';
